module.exports = __webpack_public_path__ + "static/media/Notices.ba2a327c.svg";